import React from "react";
import { ConfigProvider } from "antd";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { CourseLayout } from "./components/CourseLayout";
import "./App.css";

function App() {
  return (
    <div className="App">
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            colorPrimary: "#FF6C37",
            borderRadius: 8,
          },
        }}
      >
        <Router>
          <Routes>
            {/* Redirect the root path to the first lesson */}
            <Route
              path="/"
              element={<Navigate to="/lesson/what-is-postman" replace />}
            />

            {/* Dynamic route catching the lesson ID */}
            <Route path="/lesson/:id" element={<CourseLayout />} />
          </Routes>
        </Router>
      </ConfigProvider>
    </div>
  );
}

export default App;
